module.exports = {
    "total": 1000,
    "query": "~one=1~addr=1342+N+Church+Ct~zip=45305~records=100&uriFlag=radius",
    "pricePerPiece": {
        "singleUse": 0.0743,
        "multipleUse": 0.0943
    }
};